<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增企业库
      </a-button>
	  <a-input-search
	    placeholder="请输入搜索内容"
		:style="{ float: 'right', marginTop: '19px',width:'200px',marginRight:'20px' }"
	    allow-clear
	    @search="handleChangeActivity"
	  />
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <!-- <a
            href="javascript:;"
            @click="() => onDetails(record)"
          >查看</a>
          <a-divider
            type="vertical"
          /> -->
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
         <!-- <a-divider type="vertical" />
          <popconfirm-button
            :text="record.status===1?'禁用':'启用'"
            :alert-title="record.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          /> -->
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import { columns } from './data/index';
export default {
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      activityVisible: false,
      title: '',
      id: '',
      inputType: ['输入框', '下拉单选', '单图上传', '多图上传', '地图定位', '日期时间选择', '特殊下拉框', '下拉多选', '数据检索'],
      activityData: [],
      service_id: '',
	  keyword:''
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({
      page: String(this.current),
      pageSize: String(this.pageSize),
      keyword: this.keyword,

    });
    // this.getActivity();
  },
  methods: {
    // 获取服务活动
    async getActivity() {
      this.loading = true;
      let result = await this.$http.post(
        '/Service/getList',
        {page: 0, pageSize: 0},
      );
      if (result.data.status === 1) {
        this.activityData = [{id: '', name: '全部服务活动'}, ...result.data.data.data_list];
      }
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post(
        '/company/getCompanyInfoList',
        params,
      );
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        this.current = Number(params.page);
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
			name: item.qichacha_name,
			 oper_name: item.qichacha_oper_name,
            credit_code: item.qichacha_credit_code,
            create_time:this.$Format(item.create_time),
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    editAndAdd(record){
      if(record){
        this.$router.push({path: '/enterpriseBrand/add', query: {id: record.id, disabled: 'false'}});
      }else{
        this.$router.push({path: '/enterpriseBrand/add' });
      }

    },
    onDetails(record){
      this.$router.push({path: '/activityConfig/input', query: {id: record.id, disabled: 'true'}});
    },
    // 确认新增
    handleSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            values.pdf=values.pdf_doc_info[0].uid;
            values.id=this.id?this.id:undefined;
            let result = await this.$http.post(
              '/ServiceForm/update',
              values,
            );
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.activityVisible = false;
              this.getTableData({
                page: this.current,
                pageSize: this.pageSize,
                service_id: this.service_id,
              });
            }
          }
        },
      );
    },
    // 取消新增
    onCancel() {
      this.activityVisible = false;
    },
    // 选择服务活动
    handleChangeActivity(val){
      this.keyword=val;
      this.getTableData({
        page: 1,
        pageSize: this.pageSize,
        keyword: val,
      });
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('/ServiceForm/setStatus', {id: record.id, status: record.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize, service_id: this.service_id });
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/ServiceForm/setStatus', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize, service_id: this.service_id });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        page: String(pagination.current),
        pageSize: String(pagination.pageSize),
        service_id: this.service_id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {


}
</style>
